import React from "react";
import Logo from "../../assets/img/logo.png"

function Footer() {
  return (
    <div class="footer col-12 col-lg-11 mr-auto ml-auto mt-4">
      <div class="d-flex pt-2 justify-this flex-wrap">
        <div class="col-md-2 d-none d-sm-none d-md-block">
          <img
            src={Logo}
            class="w-100"
            alt="logo"
          />
        </div>
        <div class="location">
          <h6>Notre emplacement</h6>
          <p>
          Abidjan, <br /> Côte d'Ivoire.
          </p>
        </div>

        <div class="Legal">
          <h6>Liens rapides</h6>
          <p class="mb-0">
            <a
              href="/civwifi/#/for_homes"
              // style="color:black; text-decoration:none"
            >
              Pour les maisons
            </a>
          </p>
          <p class="mb-0">
            <a
              href="/civwifi/#/for_business"
              //   style="cursor: pointer; color:black; text-decoration:none"
            >
              Pour les entreprises
            </a>
          </p>
          <p class="mb-0">
            <a
              href="/civwifi/#/pricing"
              //   style="cursor: pointer; color:black; text-decoration:none"
            >
              Tarification
            </a>
          </p>
        </div>

        <div class="Legal">
          <h6>Juridique</h6>
          <p class="mb-0">
            <a
              href="/civwifi/#/terms"
              //  style="color:black; text-decoration:none"
            >
              Conditions d'utilisation
            </a>
          </p>
          <p>
            <a
              href="/civwifi/#/customer"
              //   style="cursor: pointer; color:black; text-decoration:none"
            >
              Code de pratique client
            </a>
          </p>
        </div>

        <div class="Pricing">
          <h6>Ressources</h6>
          <p class="mb-0">
            <a
              href="/civwifi/#/faq"
              //   style="cursor: pointer; color:black; text-decoration:none"
            >
              FAQ
            </a>
          </p>
        </div>

        <div class="social">
          <h6>Connecte-toi avec nous</h6>

          <div class="social-icons d-flex mt-2">
            <div class="mr-auto links">
              <a href="https://twitter.com/civwifi" target="_blank" rel="noreferrer">
                <i class="fa fa-twitter"></i>
              </a>
            </div>

            <div class="mr-auto links">
              <a href="https://facebook.com/civwifi" target="_blank" rel="noreferrer">
                <i class="fa fa-facebook"></i>
              </a>
            </div>

            <div class="mr-auto links">
              <a href="https://instagram.com/civwifi" target="_blank" rel="noreferrer">
                <i class="fa fa-instagram"></i>
              </a>
            </div>

            <div class="mr-auto links">
              <a href="https://linkedin.com/company/civwifi" target="_blank" rel="noreferrer">
                <i class="fa fa-linkedin-square"></i>
              </a>
            </div>
          </div>

          <div>
            <p class="mb-0">
              <a
                href="mailto:Hello@civwifi.com?Subject=Hello"
                target="_top"
                // style="text-decoration:none;color:black"
              >
                internet@civwifi.com
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Footer;
